import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PostsBase from "../component/sharedComponents/PostsBase";
import { getHomePosts, getPostById } from "../slices/2-post/thunk";
import SponsoredPost from "../component/home/SponsoredPost";
import NormalPost from "../component/home/NormalPost";
import CommentInput from "../component/SinglePost/CommentInput";
import { createComment } from "../slices/6-comment/thunk";
import avatar from "../assets/images/Avatar.avif"
import CommentItem from "../component/SinglePost/CommentItem";
import CompanyPost from "../component/home/CompanyPost";
import SectionLoader from "../component/sharedComponents/Loading/SectionLoader";
import NotFound from "../component/sharedComponents/NotFound";
import { useTranslation } from "react-i18next";

const SinglePost = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.myProfile);
  const { post, loading } = useSelector((state) => state.posts);
  const { t } = useTranslation();
  const [comment, setComment] = useState("");
  useEffect(() => {
    if (id) {
      dispatch(getPostById({ postId: id }));
    }
  }, [id, dispatch]);

  const handleAddComment = () => {
    if (!comment.trim()) return;
    dispatch(createComment({
      postId: id,
      text: comment,
    }));

    setComment("");
  };
  // console.log(post)
  if (loading) return <SectionLoader />;
  if (!post) return <NotFound />;
  // console.log(post)
  return <>
    <div className="max-w-2xl mx-auto space-y-4">
      {/* post */}
      {post.type === "ads" ? (
        <SponsoredPost
          key={post?.id}
          post={post}
        />
      ) : post.type === "company" ? (
        <CompanyPost
          key={post?.id}
          post={post}
        />
      ) : (
        <NormalPost
          key={post?.id}
          post={post}
        />
      )
      }
      <CommentInput
        userAvatar={profile?.avatar || avatar}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        onSubmit={handleAddComment}
      />
      {post?.Comments?.length > 0 ?
        <>
          <h3 className="mt-6 mb-4 text-lg font-semibold text-black dark:text-white">
            {t("postDetails.comments")}
          </h3>
          <div className="space-y-4">
            {post?.Comments?.map((comment) => (
              <CommentItem key={comment?.id} comment={comment} />
            ))}
          </div>
        </>
        : <></>
      }
    </div>
  </>;
};

export default SinglePost;
